import axios from 'axios';

export default axios.create({
  baseURL: 'http://alfred-admin-testing.amiltone.com/items/',
  headers: {
    'Content-type': 'application/json',
    'Authorization': `Bearer ${process.env.REACT_APP_ALFRED_API_KEY as string}`
  }
});
